import {handleActions} from 'redux-actions';
import {Record} from 'immutable';

import * as FeedItemActions from 'web-app/react/entities/feed/items/actions';
import {ObservationVariant} from 'web-app/react/entities/observations/constants';

import * as Actions from './actions';
import * as TypedActions from './typed-actions';

const DraftManagerModal = Record({
    isVisible: false,
    newPostRecipients: undefined,
    feedItem: undefined,
    context: '',
    singleDraftMode: false,
    disablePosts: false,
    disableObservations: false,
    observationVariant: ObservationVariant.REGULAR_OBSERVATION,
    /*
        I added this to open the assessment drafts from the list of observations.
        Apparently the assessment form expects to be given a child ID, aka selectedRecipients
     */
    selectedRecipients: undefined,
    /*
        initialValues were added as a way to open draft manager modal to write a newsfeed post with a
        custom content (from [author], selectedRecipients [recepients], richTextBody [message])
        To populate it call "showWithInitialValues" action (typed-actions.ts) and pass the 
        payload as first (and only) argument.
    */
    initialValues: undefined,
});

export default handleActions(
    {
        [Actions.show.type]: (state, {payload}) => {
            return state.merge({
                isVisible: true,
                newPostRecipients: payload.newPostRecipients,
                context: payload.context,
                feedItem: payload.feedItem,
                disablePosts: payload.disablePosts,
                disableObservations: payload.disableObservations,
                observationVariant: payload.observationVariant,
                selectedRecipients: undefined,
            });
        },
        [Actions.showObservation.type]: (state, {payload}) => {
            return state.merge({
                isVisible: true,
                newPostRecipients: payload.newPostRecipients,
                disablePosts: true,
                disableObservations: false,
                observationVariant: payload.observationVariant,
                selectedRecipients: undefined,
            });
        },
        [Actions.showObservationDraft.type]: (state, {payload}) =>
            new DraftManagerModal({
                isVisible: true,
                disablePosts: true,
                singleDraftMode: true,
                observationVariant: payload.observationVariant ? payload.observationVariant : state.observationVariant,
                selectedRecipients: payload.selectedRecipients,
            }),
        [TypedActions.showWithInitialValues.type]: (_, {payload}) =>
            new DraftManagerModal({
                isVisible: true,
                initialValues: payload,
                singleDraftMode: true,
            }),
        [Actions.hide.type]: () => new DraftManagerModal(),
        [FeedItemActions.updateItemSuccess.type]: () => new DraftManagerModal(),
    },
    new DraftManagerModal(),
);
